module.exports = __webpack_public_path__ + "img/verde.7dfc31e6.png";